import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

export const Logout: React.FC = () => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    window.localStorage.clear();
    logout({ returnTo: window.location.origin });
  };

  useEffect(() => {
    handleLogout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
